import React from "react";
import { useTranslation } from "react-i18next";
import { StatusText } from "./styles";
import { ExpenseReportStatusRef } from "../../../../../../models/expense-report-statuses";

interface Props {
  status?: ExpenseReportStatusRef | null;
}

const ExpenseReportStatus = ({ status }: Props) => {
  const tRP = "expense_report_statuses";
  const { t } = useTranslation();

  return (
    <>
      {!!status && <StatusText status={status?.id}>{status?.name ? `${t(`${tRP}.${status.name}`)}` : ""}</StatusText>}
    </>
  );
};

export default ExpenseReportStatus;
